<template>
<div style="background-color:#e0f2f1;margin-top:0px">
    <v-card flat>
        <v-container>
            <div class="row" style="padding-top:0px;">
                <div class="col-lg-9 col-md-9 col-sm-12">
                    <h1>{{news.title}}</h1>
                    <p style="text-align:justify;font-size:16px;color:grey;padding-top:15px;" class="txt" v-html="news.description"></p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12" v-if="imageList.length>0">
                    <img style="height:200px;width:100%;" class="center" :src=imageList[0].src />
                </div>
            </div>
            <div class="row" style="padding-top:25px;" v-if="imageList.length>0">
                <div class="col-lg-3 col-md-3 col-sm-12" v-for="item in imageList" :key="item.id">
                    <img style="height:200px;width:100%;" class="center" :src=item.src />
                </div>
            </div>
        </v-container>
    </v-card>
</div>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      news: {},
      imageList: []
    };
  },

  mounted() {
      this.axios
      .get(config.API + "news/author/" + this.$route.params.id, {
      })
      .then(response => {
        let res = response.data.author;

        this.news = res;

        let list = response.data.imageList;

        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.imageList.push({
                id: element.id,
                src: config.API1 + "news/files/" + element.src
            })
        }
      })
      .catch(() => {
      });
  }
};
</script>

<style lang="css" scoped>
img.center {
    display: block;
    margin: 0 auto;
}
</style>
